import { INPUT_TYPE } from "../constants/Constant";
import { Countries, IN_STATES } from "../constants/CountryConstant";
import Table from "../services/table";

export default class CompanyDetailManager {
    static getDataToUpdateForCompany = (data, columns) => {
        let contactColumns = {};
        columns.forEach((column) => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                contactColumns[column.key] = column;
            }
        });
        Object.keys(contactColumns).forEach((item) => {
            if (data[item]) {
                data[item] = data[item].map((r) => contactColumns[item].options.findIndex((op) => op.id === r));
            }
        });
    };
    static processDataForSubmit(field, defaultData) {
        let responseData = {
            finalData: defaultData,
            isValid: true
        };

            let addressFields = ['addressLine1', 'addressLine2', 'zipCode', 'city', 'state', 'country'];
            let complianceFields = ['pan', 'tan', 'tds'];
            if (field.type == INPUT_TYPE.SELECT && field.type == INPUT_TYPE.MULTI_SELECT) {// here always else part execute, will remove if part
                switch(field.columnCode){
                    case "isWorkLocation":
                        responseData.finalData[field.columnCode] = (field.options[field.value] == 'Yes') ? true: false;
                        break;
                    case "state":
                        responseData.finalData['address'][field.columnCode] = this.getCountryIdByName(field.options[field.value],IN_STATES)
                        break;
                    case "country":
                        responseData.finalData['address'][field.columnCode] = this.getCountryIdByName(field.options[field.value],Countries)
                        break;
                }

            } else {
                // address fields

                let index = -1;
                index = this.getDeepJson(field, responseData.finalData['address'], addressFields);
                // compliance fields

                index = this.getDeepJson(field, responseData.finalData['compliance'], complianceFields);
                if(index == -1) {
                    responseData.finalData[field.columnCode] = field.value;
                }
            }

        return responseData;
    }
    static getDeepJson(field, obj, fieldInclude) {
        let index = fieldInclude.indexOf(field.columnCode);
        if (index != -1) {
            obj[field.columnCode] = field.value;
        }
        return index;
    }
    static getCountryIdByName(value, List){
        let id = '';
        List.forEach(ele => {
            if(ele.name == value){
                id = ele.id;
                return ele.id;
            }
        })
        return id;
    }
}